export default {
  DEFAULT_AUTH: { userUid: null, roles: [] },
  ROLES: {
    'acard_agent': 'agent',
    'acard_financier': 'financier',
    'support': 'support',
  },
};
